import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["list", "combatant", "hp", "round"]
  static values = {
    stageId: Number,
    active: Boolean,
    activeToken: Number,
  }

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "StageChannel", id: this.stageIdValue },
      { received: (data) => this.handleBroadcast(data) }
    )
  }

  disconnect() {
    if (this.subscription) this.subscription.unsubscribe()
    if (this.consumer) this.consumer.disconnect()
  }

  handleBroadcast(data) {
    if (!data || !data.type) return
    switch (data.type) {
      case "encounter_update": this.applyEncounterUpdate(data); break
      case "token_update":     this.applyTokenUpdate(data.token); break
    }
  }

  applyEncounterUpdate(data) {
    this.activeTokenValue = data.active_token_id || 0

    // Update round badge
    if (this.hasRoundTarget) {
      this.roundTarget.textContent = data.current_round
    }

    // Highlight active combatant
    this.combatantTargets.forEach(el => {
      const id = Number(el.dataset.tokenId)
      const isActive = id === data.active_token_id
      el.classList.toggle("border", isActive)
      el.classList.toggle("border-tavern-gold", isActive)
    })
  }

  applyTokenUpdate(token) {
    if (!token) return
    // Update HP display
    const hpEl = this.hpTargets.find(el => Number(el.dataset.tokenId) === token.id)
    if (hpEl && token.current_hp !== undefined) {
      hpEl.textContent = token.current_hp
    }
  }

  async adjustHp({ params: { token, delta } }) {
    const hpEl = this.hpTargets.find(el => Number(el.dataset.tokenId) === token)
    const current = hpEl ? Number(hpEl.textContent) : 0
    await this.patchToken(token, { current_hp: current + delta })
  }

  async addCondition({ params: { token, condition } }) {
    const combatant = this.combatantTargets.find(el => Number(el.dataset.tokenId) === token)
    const existing = this.currentConditions(combatant)
    if (!existing.includes(condition)) {
      await this.patchToken(token, { conditions: [...existing, condition] })
      window.location.reload()
    }
  }

  async removeCondition({ params: { token, condition } }) {
    const combatant = this.combatantTargets.find(el => Number(el.dataset.tokenId) === token)
    const updated = this.currentConditions(combatant).filter(c => c !== condition)
    await this.patchToken(token, { conditions: updated })
    window.location.reload()
  }

  currentConditions(combatantEl) {
    if (!combatantEl) return []
    return Array.from(combatantEl.querySelectorAll("[data-encounter-condition-param]"))
                .map(el => el.dataset.encounterConditionParam)
  }

  async patchToken(id, attrs) {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const stage = this.stageIdValue
    const res = await fetch(`/stages/${stage}/stage_tokens/${id}`, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrf || "",
      },
      body: JSON.stringify({ stage_token: attrs }),
    })
    if (!res.ok) console.warn("encounter: patch failed", res.status)
    return res
  }
}
